<template>
  <div class="row">
    <div class="col s12">
        <p>
            <ul class="tabs" ref="tabs">
                <li class="tab s6"><a class="active" href="#next">Next</a></li>
                <li class="tab s6"><a href="#past">Past</a></li>
            </ul>
        </p>
    </div>
    <NextSessionList id="next" class="col s12" :user="user" />
    <PastSessionList id="past" class="col s12" :user="user" />

</div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import NextSessionList from '@/components/sessions/NextSessionList'
import PastSessionList from '@/components/sessions/PastSessionList'

export default {
  name: 'sessions',
  props: ['tab'],
  components: { NextSessionList, PastSessionList },
  data: function () {
    return {
      user: undefined
    }
  },
  created () {
    this.user = api.getCurrentUser()
  },
  mounted () {
    var tabs = M.Tabs.init(this.$refs.tabs, {})
    if (this.tab) tabs.select(this.tab)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Sessions.vue